/**
 * Posições dos pins (% do canvas) — uma layout por faixa de nível.
 * Sincronizar com public/assets/world/world-map-layouts.json (ferramentas Node).
 */
export const SCHEMATIC_HUB = { x: 50, y: 50 };

const L = (layout) => Object.freeze({ ...layout });

/** Índice = band (0 = Nv.1 … 10 = Nv.300). */
export const ROUTE_NODE_ANCHORS_BY_BAND = Object.freeze([
  L({
    /* Nv.1 — prados Saffron: lago SW, floresta NW, montanha NE (arte aprovada) */
    planta: [22, 18], inseto: [34, 12], voador: [48, 8], gelo: [88, 14], dragão: [93, 10],
    psíquico: [36, 42], lutador: [72, 26], aço: [78, 18], elétrico: [91, 48], pedra: [57, 20],
    sombrio: [86, 56], fantasma: [16, 30], água: [14, 65], veneno: [20, 44], normal: [30, 78],
    fada: [49, 56], fogo: [40, 86], terra: [66, 78],
  }),
  L({
    /* Nv.10 — trilha Viridian: lago NORTE, floresta OESTE, prados SUL, morros LESTE */
    planta: [12, 32], inseto: [18, 22], voador: [55, 10], gelo: [90, 15], dragão: [92, 22],
    psíquico: [32, 48], lutador: [78, 32], aço: [80, 25], elétrico: [88, 52], pedra: [85, 38],
    sombrio: [82, 68], fantasma: [8, 45], água: [40, 18], veneno: [22, 58], normal: [42, 72],
    fada: [36, 76], fogo: [35, 85], terra: [72, 78],
  }),
  L({
    /* Nv.20 — floresta Pewter: mata dominante, lago SE, montanhas OESTE */
    planta: [28, 20], inseto: [38, 15], voador: [52, 12], gelo: [8, 12], dragão: [22, 18],
    psíquico: [45, 35], lutador: [58, 28], aço: [25, 35], elétrico: [85, 42], pedra: [18, 28],
    sombrio: [75, 55], fantasma: [15, 42], água: [82, 78], veneno: [32, 48], normal: [62, 65],
    fada: [55, 52], fogo: [12, 55], terra: [48, 72],
  }),
  L({
    /* Nv.40 — bosques sombrios: rio OESTE, ruínas SUL, floresta escura NE */
    planta: [72, 22], inseto: [65, 15], voador: [40, 10], gelo: [92, 20], dragão: [88, 12],
    psíquico: [50, 28], lutador: [62, 38], aço: [35, 25], elétrico: [78, 45], pedra: [55, 82],
    sombrio: [85, 62], fantasma: [18, 35], água: [4, 54], veneno: [82, 48], normal: [28, 68],
    fada: [42, 58], fogo: [50, 88], terra: [68, 75],
  }),
  L({
    /* Nv.60 — pântano: água NORTE, pântano SUL, pedra LESTE */
    planta: [14, 35], inseto: [22, 22], voador: [62, 8], gelo: [48, 6], dragão: [94, 18],
    psíquico: [68, 38], lutador: [75, 28], aço: [84, 32], elétrico: [92, 55], pedra: [88, 45],
    sombrio: [32, 85], fantasma: [10, 58], água: [52, 14], veneno: [28, 72], normal: [82, 62],
    fada: [38, 74], fogo: [78, 82], terra: [45, 88],
  }),
  L({
    /* Nv.80 — cavernas: água OESTE subterrânea, gelo NORTE, pedra LESTE */
    planta: [35, 18], inseto: [76, 52], voador: [58, 12], gelo: [50, 10], dragão: [90, 22],
    psíquico: [42, 48], lutador: [70, 35], aço: [80, 28], elétrico: [88, 58], pedra: [82, 38],
    sombrio: [22, 68], fantasma: [18, 55], água: [8, 42], veneno: [40, 78], normal: [55, 58],
    fada: [32, 62], fogo: [55, 90], terra: [48, 65],
  }),
  L({
    /* Nv.100 — ilha vulcânica: oceano, fogo SUL, água OESTE */
    planta: [48, 22], inseto: [38, 32], voador: [72, 18], gelo: [70, 8], dragão: [58, 75],
    psíquico: [28, 52], lutador: [28, 38], aço: [75, 48], elétrico: [18, 28], pedra: [88, 55],
    sombrio: [82, 72], fantasma: [12, 62], água: [12, 48], veneno: [35, 58], normal: [68, 58],
    fada: [38, 72], fogo: [52, 82], terra: [42, 72],
  }),
  L({
    /* Nv.150 — cinzas: lava NORTE, água SE tóxica, pedra OESTE */
    planta: [25, 75], inseto: [18, 65], voador: [35, 55], gelo: [8, 18], dragão: [72, 22],
    psíquico: [28, 62], lutador: [38, 42], aço: [65, 35], elétrico: [78, 52], pedra: [15, 45],
    sombrio: [55, 85], fantasma: [22, 38], água: [85, 88], veneno: [68, 72], normal: [52, 72],
    fada: [32, 58], fogo: [48, 18], terra: [46, 68],
  }),
  L({
    /* Nv.200 — arquipélago: cada bioma em ilha diferente */
    planta: [20, 48], inseto: [15, 28], voador: [38, 22], gelo: [62, 12], dragão: [78, 18],
    psíquico: [38, 28], lutador: [72, 42], aço: [82, 28], elétrico: [92, 42], pedra: [88, 58],
    sombrio: [65, 68], fantasma: [12, 72], água: [35, 35], veneno: [28, 82], normal: [55, 78],
    fada: [22, 46], fogo: [45, 88], terra: [75, 82],
  }),
  L({
    /* Nv.250 — mar glacial: gelo NORTE, água OESTE congelada, fogo SUL termal */
    planta: [18, 78], inseto: [18, 58], voador: [48, 12], gelo: [50, 8], dragão: [85, 15],
    psíquico: [66, 28], lutador: [72, 55], aço: [82, 58], elétrico: [90, 48], pedra: [90, 35],
    sombrio: [15, 65], fantasma: [10, 48], água: [12, 40], veneno: [22, 82], normal: [22, 66],
    fada: [26, 76], fogo: [48, 88], terra: [62, 75],
  }),
  L({
    /* Nv.300 — limiar místico: biomas flutuantes em posições surreais */
    planta: [22, 68], inseto: [15, 52], voador: [35, 38], gelo: [25, 12], dragão: [88, 22],
    psíquico: [50, 15], lutador: [84, 48], aço: [62, 28], elétrico: [82, 58], pedra: [72, 72],
    sombrio: [12, 38], fantasma: [8, 55], água: [18, 30], veneno: [30, 85], normal: [72, 68],
    fada: [38, 45], fogo: [62, 85], terra: [78, 75],
  }),
]);

export function routeNodeAnchorsForBand(band) {
  const i = Math.max(0, Math.min(ROUTE_NODE_ANCHORS_BY_BAND.length - 1, Number(band) || 0));
  return ROUTE_NODE_ANCHORS_BY_BAND[i];
}

/** @deprecated use routeNodeAnchorsForBand */
export const ROUTE_NODE_ANCHORS = ROUTE_NODE_ANCHORS_BY_BAND[0];
export const SCHEMATIC_ROUTE_LAYOUT = ROUTE_NODE_ANCHORS;
